(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const SELECTORS = ['[class*="onair-v2-"] h1','[class*="onair-v2-"] h2','[class*="onair-v2-"] h3','[class*="onair-v2-"] [class*="__intro"] > *','[class*="onair-v2-"] [class*="__header"] > *','[class*="onair-v2-"] [class*="__card"]','[class*="onair-v2-"] [class*="__feature"]','[class*="onair-v2-"] [class*="__spec"]','[class*="onair-v2-"] [class*="__trust"] > *'];
  function normalizeHelpLinks(scope = document) {
    const links = scope.querySelectorAll ? scope.querySelectorAll('.product--query-form-title') : [];
    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href === '/' || href === '/product-query-form') link.setAttribute('href', '/pages/contact');
    });
  }
  function normalizeText(value = '') {
    return value.replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function addBuilderDetailLinks(scope = document) {
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('[class*="bundle-product-content-"]').forEach(content => {
      if (content.querySelector('.onair-v2-builder-view-details')) return;
      const title = content.querySelector('[class*="bundle-product-title-"]');
      if (!title) return;
      const productTitle = title.textContent.replace(/\s+/g, ' ').trim();
      if (!productTitle) return;
      const fallbackUrl = `/search?q=${encodeURIComponent(productTitle)}&type=product`;
      const link = document.createElement('a');
      link.className = 'onair-v2-builder-view-details';
      link.href = fallbackUrl;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'View Details →';
      link.addEventListener('click', async event => {
        event.preventDefault();
        event.stopPropagation();
        const tab = window.open('about:blank', '_blank');
        if (tab) tab.opener = null;
        try {
          const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(productTitle)}&resources[type]=product&resources[limit]=10`);
          if (!response.ok) throw new Error('Product lookup failed');
          const data = await response.json();
          const products = data?.resources?.results?.products || [];
          const exact = products.find(product => normalizeText(product.title) === normalizeText(productTitle));
          const destination = exact?.url || products[0]?.url || fallbackUrl;
          if (tab) tab.location.href = destination;
          else window.location.href = destination;
        } catch (error) {
          if (tab) tab.location.href = fallbackUrl;
          else window.location.href = fallbackUrl;
        }
      });
      title.insertAdjacentElement('afterend', link);
    });
  }
  function setup(scope = document) {
    normalizeHelpLinks(scope);
    addBuilderDetailLinks(scope);
    const main = scope.querySelector ? (scope.matches?.('#MainContent') ? scope : scope.querySelector('#MainContent') || scope) : document;
    const candidates = [...main.querySelectorAll(SELECTORS.join(','))].filter(el => !el.closest('[hidden]') && !el.classList.contains('onair-v2-reveal'));
    if (!candidates.length) return;
    document.documentElement.classList.add('onair-v2-motion-ready');
    candidates.forEach((el, index) => {
      el.classList.add('onair-v2-reveal');
      el.dataset.onairV2Delay = String(index % 4);
      if (/^H[1-3]$/.test(el.tagName)) el.classList.add('onair-v2-accent-sweep');
      if (el.className && typeof el.className === 'string' && /__card|__feature|__spec/.test(el.className)) el.classList.add('onair-v2-hover-card');
    });
    if (reduceMotion.matches || !('IntersectionObserver' in window)) { candidates.forEach(el => el.classList.add('is-onair-v2-visible')); return; }
    const observer = new IntersectionObserver(entries => { entries.forEach(entry => { if (!entry.isIntersecting) return; entry.target.classList.add('is-onair-v2-visible'); observer.unobserve(entry.target); }); }, { rootMargin:'0px 0px -6% 0px', threshold:.08 });
    candidates.forEach(el => observer.observe(el));
  }
  const run = () => setup(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once:true }); else run();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
